import { QRCodeSVG } from 'qrcode.react';
import { CARD_W, CARD_H } from './cardSize';

export default function BohoGreenery({ data, style }) {
  const { groomName, brideName, date, time, venue, address, message: msg, qrValue } = data || {};

  return (
    <div
      className="inv-card"
      style={{
        width: CARD_W, height: CARD_H,
        background: 'linear-gradient(160deg, #F7F6EE, #EFF3E6)',
        border: '2px solid #A9BA9D',
        borderRadius: 14,
        padding: '8mm 9mm',
        fontFamily: "'Segoe UI', 'Helvetica Neue', sans-serif",
        color: '#3F5237',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {/* Leaf corners */}
      <div style={{ position: 'absolute', top: -6, left: -4, fontSize: 30, opacity: 0.45, transform: 'rotate(-15deg)' }}>🌿</div>
      <div style={{ position: 'absolute', bottom: -6, right: -4, fontSize: 30, opacity: 0.45, transform: 'rotate(165deg)' }}>🌿</div>

      <div style={{ fontSize: 9, letterSpacing: 3, textTransform: 'uppercase', color: '#7C9473', marginBottom: 6, fontWeight: 600 }}>
        Sevgi bilan taklif etamiz
      </div>

      <div style={{ fontSize: 21, fontWeight: 700, color: '#3F5237', lineHeight: 1.25, textAlign: 'center', fontFamily: "'Georgia', serif" }}>
        {groomName || 'Kuyov'} <span style={{ fontSize: 15, color: '#8AA77B', margin: '0 6px' }}>&</span> {brideName || "Kelin"}
      </div>

      <div style={{
        width: 60, height: 1.5, margin: '8px 0',
        background: 'linear-gradient(90deg, transparent, #8AA77B, transparent)',
      }} />

      <div style={{ fontSize: 11, textAlign: 'center', lineHeight: 1.55, color: '#516B47' }}>
        {date && <div style={{ fontWeight: 600 }}>{date}</div>}
        {time && <div>Soat: {time}</div>}
        {venue && <div style={{ fontWeight: 600, color: '#3F5237', marginTop: 2 }}>{venue}</div>}
        {address && <div style={{ fontSize: 9.5, opacity: 0.8 }}>{address}</div>}
      </div>

      {msg && (
        <div style={{ fontSize: 8.5, fontStyle: 'italic', textAlign: 'center', color: '#7C9473', marginTop: 6, maxWidth: '78%' }}>
          {msg}
        </div>
      )}

      {qrValue && (
        <div style={{ position: 'absolute', bottom: '5mm', right: '5mm' }}>
          <QRCodeSVG value={qrValue} size={46} level="M" fgColor="#3F5237" bgColor="transparent" />
        </div>
      )}
    </div>
  );
}
